export default __webpack_public_path__ + "static/08.02-5d2815bddb2378101d1bc8d5979b7a50.png";